import { v4 as uuidV4 } from 'uuid';
import { QueryParamsType } from '@/api/helpers/apiParamsHelpers';
import { prepareBaseListApiParams } from '@/api/helpers/apiHelpers';
import { ValueOf } from '@/types/sharedTypes';

export const IDEMPOTENCY_KEY = {
  CREATE_TRANSACTION: 'createTransaction',
  CREATE_DEPOSIT_ACCOUNT: 'createDepositAccount',
  CREATE_WIRE: 'createWire',
  PROVIDE_PAYMENT_DETAILS: 'providePaymentDetails',
  CREATE_VAULT_ACCOUNT: 'createVaultAccount',
  ADD_VAULT_ACCOUNT_RAILS: 'addVaultAccountRails',
  CREATE_SECURE_LINK: 'createSecureLink',
  CREATE_RECIPIENT_REQUEST: 'createRecipientRequest',
  CREATE_DASHBOARD_TASK: 'createDashboardTask',
  CREATE_INVOICE_LINK: 'createInvoiceLink',
  CREATE_INVOICE_CHECK: 'createInvoiceCheck',
} as const;

type IdempotencyKeyType = ValueOf<typeof IDEMPOTENCY_KEY>;

const IDEMPOTENCY_KEY_STORAGE = {};

export const getAuthConfirmationTokenHeader = (pinToken: string) => {
  return {
    requestHeaders: {
      'X-Auth-Confirmation-Token': pinToken,
    },
  };
};

export const getIdempotencyKeyHeader = (idempotencyKey: string) => {
  return {
    requestHeaders: {
      'X-Idempotency-Key': idempotencyKey,
    },
  };
};

export const idempotencyKeyHandler = (idempotencyAction: IdempotencyKeyType) => {
  if (!idempotencyAction) return;

  const clearKey = () => {
    delete IDEMPOTENCY_KEY_STORAGE[idempotencyAction];
  };

  const getKey = () => {
    const existingKey = IDEMPOTENCY_KEY_STORAGE[idempotencyAction];

    if (existingKey) return existingKey;

    const newKey = uuidV4();

    IDEMPOTENCY_KEY_STORAGE[idempotencyAction] = newKey;

    return newKey;
  };

  const key = getKey();

  return {
    header: getIdempotencyKeyHeader(key),
    clearKey,
  };
};

export const prepareSearchNameListApiParams = (queryParams: QueryParamsType) => {
  const baseParams = prepareBaseListApiParams(queryParams);

  const params = {
    ...baseParams,
  };

  if (queryParams?.name) {
    params.name = queryParams.name;
  }

  return params;
};
